export default "__VITE_ASSET__pkMh7_yn__"